import React, { useState } from "react";
import "./QueriesTable.css";
import { useNavigate } from "react-router-dom";
import { useChatData } from "../../../Context/chatDataContext";
import AddQuoteModal from "../../Chats/AddQuoteModal/AddQuoteModal";
import { sendMessageApi } from "../../../utils/APIs/chatApis";
import { toast } from "react-toastify";
import ViewDetailsModal from "../../../components/ViewDetailsModal/ViewDetailsModal";
import {
  buildQueryDetailRows,
  formatRequirements,
} from "../../../utils/viewDetailsBuilders";

const QueriesTable = ({ data, page, limit, refreshData }) => {
  const navigate = useNavigate();
  const { setQuote } = useChatData();
  const [queries, setQueries] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handleChatClick = (quote) => {
    setQuote(quote);
    navigate(`/chat/queries/${quote._id}`);
  };

  const handleBudgetClick = (quote) => {
    setShowPaymentModal(true);
    setQueries(quote);
  };

  const handleViewDetails = (item) => {
    setSelectedItem(item);
    setShowDetailsModal(true);
  };

  const handleQuoteSend = async (payload) => {
    if (!queries._id) return;
    try {
      const res = await sendMessageApi(queries._id, payload);
      if (res?.data?.success) {
        toast.success("Budget sent successfully!");
        if (refreshData) refreshData();
      } else {
        toast.error(res?.data?.message || "Failed to send budget.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to send budget.");
    }
  };

  return (
    <div className="quote-table-wrapper">
      <table className="quote-table">
        <thead>
          <tr>
            <th>Sr.</th>
            <th>Event Type</th>
            <th>Event Location</th>
            <th>Requirement</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Details</th>
            <th>Chat</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="11" className="no-data">
                No Queries found
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={index}>
                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                <td>{item.eventType || "-"}</td>
                <td>{item.location || "-"}</td>
                <td>{formatRequirements(item.requirements)}</td>
                <td>{item?.clientName || "-"}</td>
                <td>{item?.clientId?.mobileNumber || "-"}</td>
                <td className="email">{item?.clientId?.email || "-"}</td>

                <td>
                  <button
                    type="button"
                    className="view-details-btn"
                    onClick={() => handleViewDetails(item)}
                  >
                    View Details
                  </button>
                </td>

                <td>
                  <button
                    className="chat-btn"
                    onClick={() => handleChatClick(item)}
                  >
                    💬
                  </button>
                </td>

                <td>
                  <button
                    className="chat-btn"
                    onClick={() => handleBudgetClick(item)}
                  >
                    Budget
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <ViewDetailsModal
        isOpen={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="Query Details"
        rows={buildQueryDetailRows(selectedItem)}
      />

      <AddQuoteModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onSubmit={handleQuoteSend}
        refreshData={refreshData}
        queryData={queries}
      />
    </div>
  );
};

export default QueriesTable;
